import styled from "styled-components";

export const PictureUploadWrapper = styled.div`


    width: 300px;
    min-width: 300px;
    min-height: 175px;
    border: 1.5px dashed #c3e3b8;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: border-color 0.25s, background-color 0.25s;
    position: relative;
    border-radius: 14px;
    background-color: #fafdf8;
    overflow: hidden;
    user-select: none;
    &:hover {
    border-color: #509540;
    background-color: #f0f7ed;
  }

  .showTextImg{
    padding: 20px;
    img{
        width: 28px;
        height: 28px;
        display: block;
        margin-inline: auto;
    }
    .uploadSvg{
        width: 46px;
        height: 46px;
        display: block;
        margin-inline: auto;
        color: #509540;
        background: #e6f3e0;
        border-radius: 50%;
        padding: 11px;
        box-shadow: 0 4px 12px rgba(80,149,64,0.18);
    }
  }

    p{
    font-size: 12px;
    line-height: 1.5;
    color: #6f7878;
    max-width: 200px;
    margin-inline: auto;
  }
  
  .preview-container {
    position: relative;
    width: 300px;
    min-height: 140px;
    img {
    max-width: 100%;
    max-height: 100%;
  }
  .remove-icon {
    position: absolute;
    top: 10px;
    right: 10px;
    background: rgba(255, 255, 255, 0.7);
    border-radius: 50%;
    padding: 0px;
    cursor: pointer;
    height: 26px;
    width: 26px;
    text-align: center;
    &:hover {
    background: rgba(255, 255, 255, 1);
  }
  }
  }
`;